import { PlatformIntegration } from '@/platform/platform-integration';
import { ReflectorIntegration } from '@/infrastructure/reflector/reflector-integration';
import { ReflectorOrganisation } from '@/infrastructure/reflector/reflector-organisation';
import { ReflectorResponse } from '@/infrastructure/reflector/reflector-response';
import { arrayFirstItemOrNull } from '@/platform/core/array-extensions';

import { Organisation } from './organisation';

class OrganisationPresenter extends ReflectorIntegration {
	public async retrieveByIds(ids: readonly string[]): Promise<readonly Organisation[]> {
		if (ids.length === 0) {
			return [];
		}

		const authorization = await PlatformIntegration.instance.authorizer.authorizeOrganizationQuery();

		const response = await this.send<ReflectorOrganisation>(
			`data/organisations/public/list/`,
			`ids-${ids.join(',')}`,
			authorization
		);

		return this.reconstitute(response);
	}

	public async retrieve(id: string): Promise<Organisation | null> {
		const authorization = await PlatformIntegration.instance.authorizer.authorizeOrganizationQuery();

		const response = await this.send<ReflectorOrganisation>(
			`data/organisations/public/list/`,
			`ids-${id}`,
			authorization
		);
		const organisations = this.reconstitute(response);

		return arrayFirstItemOrNull(organisations);
	}

	public async search(query: string | undefined): Promise<readonly Organisation[]> {
		if (query === undefined || query.trim().length === 0) {
			return [];
		}

		const authorization = await PlatformIntegration.instance.authorizer.authorizeOrganizationQuery();

		const response = await this.send<ReflectorOrganisation>(
			`data/organisations/public/list/`,
			this.determineSearchQuery(query),
			authorization
		);
		const organisations = this.reconstitute(response);

		return organisations;
	}

	private reconstitute(response: ReflectorResponse<ReflectorOrganisation>): readonly Organisation[] {
		return Array.isArray(response)
			? []
			: Object.values(response).map((source) => new Organisation(source.id, source.name));
	}
}

export default new OrganisationPresenter();
